var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',[_c('pg-header')],1),_vm._v(" "),_c('el-container',{staticClass:"el-body"},[_c('ir-slider',[_c('el-aside',[(_vm.loadNav)?_c('pg-navmenu',{attrs:{"datalist":_vm.datalist}}):_vm._e()],1)],1),_vm._v(" "),_c('el-main',{attrs:{"id":"loadingArea"}},[_c('router-view',{key:_vm.key})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64bed6a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Home/Index.vue
// module id = null
// module chunks = 